import { CUSTOMERS } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import CustomerPage from "./container/CustomerPage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: CUSTOMERS,
    withSidebar: true,
    withAppBar: true,
    component: CustomerPage,
  };
}
